export const PRICE = {
  berufsmantelprimo: 49.0,
  classicohose: 62.0,
  classicojacke: 59.0,
  classicoshorts: 48.0,
  damenasackprimo: 52.0,
  dynamix: 89.0,
  fleecejackeprimo: 56.0,
  giletprimorv: 34.0,
  gilletprimoknopfen: 34.0,
  latzhoseprimo: 68.0,
  opticahose: 0.0,
  overallprimo: 98.0,
  parkaprimoaussenjacke: 189.0,
  parkaprimoinnenjacke: 179.0,
  polar: 59.0,
  softshelljackeprimo: 79.0,
  softshelljackeprimoplus: 109.0,
  trend: 66.0,
  trendgilet: 49.0,
  ultimatetrousers: 99.0,
  reflectivestrips: 9.0,
  cordura: 9.9,
  multipocket: 7.9,
  logo: 4.9,
  ripstop: 0.0,
  escelade: 0.0,
  sotina: 0.0,
  sotinaplus: 0.0,
  baumwolle: 0.0,
  mischgewebe: 0.0,
  fleecepolar230: 0.0,
  fleecepolar280: 0.0,
  softshell: 0.0,
};
